import type { DummyFoods } from './dummyFoods'

export const flour: DummyFoods = {
  Flour: {
    Almond: ['Almond flour'],
    Arrowroot: ['Arrowroot flour'],
    Chickpea: ['Chickpea flour'],
    Coconut: ['Coconut flour'],
    Hazelnut: ['Hazelnut flour'],
    Oat: ['Oat flour'],
    Peanut: ['Peanut flour'],
    White: ['White flour'],
    'Whole wheat': ['Whole wheat flour'],
  },
}
